// Viewer — the resolved identity context that every canRead/canWrite call
// runs against. Server routes build it explicitly from the loaded session user
// with `viewerFromUser()`. There is no shipped `req.viewer` plugin, Redis
// viewer cache, or permission-cache invalidation subscriber today.
import { z } from 'zod';
import { RoleId } from '../members/role.js';
export const Viewer = z.object({
    /** Null for guest (no session). When null, primaryRole MUST be 'guest'. */
    userId: z.string().uuid().nullable(),
    primaryRole: RoleId,
    /** All roles assigned (most users have 1; a parent who is also a member has 2). */
    roles: z.array(RoleId),
    /** Computed max rank across `roles` — drives action gating. */
    maxRank: z.number().int().min(0),
    /** Groups the viewer is in, by id. */
    groupIds: z.array(z.string().uuid()),
    /** Per-group role within each group; empty string when not in. */
    groupRoles: z.record(z.string(), z.enum(['member', 'moderator', 'owner']).optional()),
    /** parent → children: when role includes 'parent'. */
    parentOf: z.array(z.string().uuid()),
    /** child → parents: when role includes 'child'. */
    childOf: z.array(z.string().uuid()),
    /** Manager-managed groups (manages: ['g-workshop']). */
    manages: z.array(z.string().uuid()),
    /** Employee-staffed groups (used by attendance.mark canWrite check). */
    worksIn: z.array(z.string().uuid()),
    /** Child-enrolled workshop groups. */
    enrolledIn: z.array(z.string().uuid()),
    /** Optional: extra signals (paid subscriber, 2FA satisfied, …). */
    flags: z.record(z.string(), z.boolean()).optional(),
});
/** Synthetic guest viewer — the fall-back used by routes when no session exists. */
export const GUEST_VIEWER = {
    userId: null,
    primaryRole: 'guest',
    roles: ['guest'],
    maxRank: 10,
    groupIds: [],
    groupRoles: {},
    parentOf: [],
    childOf: [],
    manages: [],
    worksIn: [],
    enrolledIn: [],
};
//# sourceMappingURL=viewer.js.map